import Axios from 'axios'
import Config from '@/config'
import Store from '@/store/index'

Axios.defaults.baseURL = Config.apiUrl

Axios.interceptors.request.use(function (axiosConfig) {
  axiosConfig.headers['Authorization'] = `Bearer ${ Store.state.user.token }`;
  return axiosConfig;
}, function (error) {
  return Promise.reject(error);
});

Axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.status === 401 && Store.state.user.auth) {
    Store.dispatch('user/sessionExpired');
  }
  return Promise.reject(error);
});
